const state = () => ({
  allUsers: [],
  totalUsers: 0,
  loading: false,
  errors: [],
  flashErrorMessage: '',
  flashError: false,
  totalPage: 0,
  usersMerchantDetail: [],
  usersMerchant: [],
  totalUsersMerchant: 0,
  BioDetailList: [],
  BioTotalList: 0,
  BioTotalPage: 0,
  isDisabledBlock : false,
});

export default state;